// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DiWcC1 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3, 24px);
  color: var(--text-neutral-dark, #1f1f1f);
  padding-top: 4px;
  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);
}

.kEum30 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 36.519428px;
  padding-right: 24px;
}

.kEum30 h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
}

.oUJ3Yl {
  display: grid;
  grid-template-columns: minmax(0, 733fr) minmax(0, 355fr);
  gap: var(--spacing-3, 24px);
}

.ojsNs3 {
  display: flex;
  flex-direction: column;
  height: calc(100dvh - 176.519428px);
  min-height: 400px;
  overflow: hidden;
}

._ie57M {
  box-sizing: border-box;
  display: flex;
  height: 48px;
  flex-shrink: 0;
  padding: 12px 12px 0;
  border-bottom: 1px solid var(--stroke-neutral-subtle, #f2f2f2);
  background-color: var(--surface-neutral-white, #fff);
}

.fmgRaO {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 8px;
  border-bottom: 2px solid var(--stroke-primary-medium, #d64000);
  color: var(--text-primary-medium, #d64000);
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
}

.uGMX_E {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.kddUoD {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 11px;
  align-content: start;
}

.Lg6TRy {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  height: 111px;
  min-width: 0;
  overflow: hidden;
  color: var(--text-neutral-dark, #1f1f1f);
  font-family: var(--font-family-base);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6;
}

.Lg6TRy:focus-visible {
  outline: 2px solid var(--stroke-primary-medium, #d64000);
  outline-offset: 2px;
}

.lYxQYf {
  width: 16px;
  height: 16px;
}

.ivrmHy {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: left top;
}

.jqcqDK {
  width: 100%;
  height: 111px;
  object-fit: cover;
  object-position: left top;
}

@media (max-width: 767px) {
  .oUJ3Yl {
    grid-template-columns: 1fr;
  }

  .kEum30 {
    padding-right: 0;
  }

  .ojsNs3 {
    height: 70vh;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/LegacyBenefitsHistoryPage/LegacyBenefitsHistoryPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,wCAAwC;EACxC,gBAAgB;EAChB,wEAAwE;AAC1E;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,8DAA8D;EAC9D,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,8DAA8D;EAC9D,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;EACxC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;EACxD,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3, 24px);\n  color: var(--text-neutral-dark, #1f1f1f);\n  padding-top: 4px;\n  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);\n}\n\n.heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-height: 36.519428px;\n  padding-right: 24px;\n}\n\n.heading h1 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: minmax(0, 733fr) minmax(0, 355fr);\n  gap: var(--spacing-3, 24px);\n}\n\n.historyCard {\n  display: flex;\n  flex-direction: column;\n  height: calc(100dvh - 176.519428px);\n  min-height: 400px;\n  overflow: hidden;\n}\n\n.historyHeader {\n  box-sizing: border-box;\n  display: flex;\n  height: 48px;\n  flex-shrink: 0;\n  padding: 12px 12px 0;\n  border-bottom: 1px solid var(--stroke-neutral-subtle, #f2f2f2);\n  background-color: var(--surface-neutral-white, #fff);\n}\n\n.historyTab {\n  display: flex;\n  align-items: center;\n  margin: 0;\n  padding: 8px;\n  border-bottom: 2px solid var(--stroke-primary-medium, #d64000);\n  color: var(--text-primary-medium, #d64000);\n  font-size: 14px;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.historyBody {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.consultations {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 11px;\n  align-content: start;\n}\n\n.consultationCard {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  height: 111px;\n  min-width: 0;\n  overflow: hidden;\n  color: var(--text-neutral-dark, #1f1f1f);\n  font-family: var(--font-family-base);\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.6;\n}\n\n.consultationCard:focus-visible {\n  outline: 2px solid var(--stroke-primary-medium, #d64000);\n  outline-offset: 2px;\n}\n\n.consultationIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.historySkeleton {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: left top;\n}\n\n.shortcutSkeleton {\n  width: 100%;\n  height: 111px;\n  object-fit: cover;\n  object-position: left top;\n}\n\n@media (max-width: 767px) {\n  .grid {\n    grid-template-columns: 1fr;\n  }\n\n  .heading {\n    padding-right: 0;\n  }\n\n  .historyCard {\n    height: 70vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DiWcC1`,
	"heading": `kEum30`,
	"grid": `oUJ3Yl`,
	"historyCard": `ojsNs3`,
	"historyHeader": `_ie57M`,
	"historyTab": `fmgRaO`,
	"historyBody": `uGMX_E`,
	"consultations": `kddUoD`,
	"consultationCard": `Lg6TRy`,
	"consultationIcon": `lYxQYf`,
	"historySkeleton": `ivrmHy`,
	"shortcutSkeleton": `jqcqDK`
};
module.exports = ___CSS_LOADER_EXPORT___;
